// Generated by scripts/build-info.mjs - do not edit, not committed.
export const BUILD_INFO = {
  sha: '3e33f357f489b53ccfa801250d4c0343f998b937',
  short: '3e33f35',
  builtAt: '2026-11-04T15:31:59.175Z',
} as const;
